export default __webpack_public_path__ + "static/media/img-01.725f8d3a.jpg";